import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { authorizedTo, id, meta, entityItem, target, targetForm } from '../..';

const data = t.type({
  title: t.string,
  hardwareId: t.string,
  entityItem: t.union([entityItem, t.null]),
  active: t.boolean,
  alarmsActive: t.boolean,
  temperatureLastMeasurement: t.union([t.number, t.null]),
  temperatureLowerBound: t.union([t.number, t.null]),
  temperatureUpperBound: t.union([t.number, t.null]),
  humidityLastMeasurement: t.union([t.number, t.null]),
  humidityLowerBound: t.union([t.number, t.null]),
  humidityUpperBound: t.union([t.number, t.null]),
  lastMeasuredAt: t.union([DateFromUnixTime, t.null]),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data: t.intersection([
    data,
    t.type({
      createIssueFor: t.union([target, t.null]),
      delayCreatingIssueBy: t.number,
      granularity: t.union([t.number, t.null]),
    }),
  ]),
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  hardwareId: t.string,
  entityItem: t.union([t.number, t.null]),
  active: t.boolean,
  alarmsActive: t.boolean,
  temperatureLastMeasurement: t.union([t.number, t.null]),
  humidityLastMeasurement: t.union([t.number, t.null]),
  lastMeasuredAt: t.union([DateFromUnixTime, t.null]),
  temperatureLowerBound: t.union([t.number, t.null]),
  temperatureUpperBound: t.union([t.number, t.null]),
  humidityLowerBound: t.union([t.number, t.null]),
  humidityUpperBound: t.union([t.number, t.null]),
  createIssueFor: t.union([targetForm, t.null]),
  delayCreatingIssueBy: t.number,
  alarmUsers: t.array(t.number),
  granularity: t.union([t.number, t.null]),
});
